// extracted by mini-css-extract-plugin
export default {"codeInput":"form_codeInput__ayBeL","label":"form_label__HOZl+","form":"form_form__3TBro","form-container":"form_form-container__+I3OE"};